import React, {
    FC,
    useState,
} from "react";
import {
    Avatar,
    Box,
    Menu,
    MenuItem,
    Typography,
} from "@mui/material";
import {
    ArrowDropDown,
    Person,
} from "@mui/icons-material";
import {Locale} from "../../locales/Locale";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";
import {useNavigate} from "react-router-dom";
import {RoutesPath} from "../../enums/RoutesPath";

interface IAuthorizedUser {
    user: any;
    onLogout: () => void;
}

export const AuthorizedUser: FC<IAuthorizedUser> = ({user, onLogout}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const navigate = useNavigate();
    const handleMenuToggle = (event: React.MouseEvent<HTMLElement>) => {
        if (anchorEl) {
            setAnchorEl(null);
        }
        else {
            setAnchorEl(event.currentTarget);
        }
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const [firstName] = user.name.split(" ");
    const handleRedirectToFavourites = () => {
        navigate(RoutesPath.FAVOURITES);
    };
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: theme => theme.palette.button.primary,
                color: theme => theme.palette.button.text,
                border: "1px solid rgba(0, 0, 0, 0.1)",
                borderRadius: "4px",
                padding: "3px 6px",
                height: 30,
                "&:hover": {
                    backgroundColor: theme => theme.palette.button.hover,
                },
                transition: "background-color 0.2s",
            }}
            onClick={handleMenuToggle}
        >
            <Avatar
                src={user.picture?.data?.url || ""}
                alt={user.name}
                sx={{
                    width: 20,
                    height: 20,
                    marginRight: "8px",
                }}
            >
                {!user.picture?.data?.url && <Person sx={{color: theme => theme.palette.button.text}}/>}
            </Avatar>
            <Typography
                variant="body2"
                sx={{
                    fontWeight: 500,
                    color: theme => theme.palette.button.text,
                    lineHeight: "1.5",
                    marginRight: "4px",
                }}
            >
                {firstName}
            </Typography>
            <ArrowDropDown
                sx={{
                    transition: "transform 0.2s",
                    transform: anchorEl ? "rotate(180deg)" : "rotate(0deg)",
                    color: theme => theme.palette.button.text,
                }}
            />
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItem disabled>{user.name}</MenuItem>
                <MenuItem onClick={handleRedirectToFavourites}><Locale localeId={IdlocaGeneric.favourites}/></MenuItem>
                <MenuItem onClick={onLogout}><Locale localeId={IdlocaGeneric.logout}/></MenuItem>
            </Menu>
        </Box>
    );
};
